import React from 'react';
import { Typography, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { ListIndicator }
  from 'src/scenes/Project/components';
import { LabelChip } from 'src/components';


const useStyles = makeStyles(theme => ({
  container: {
    width: '70%',
  },
  title: {
    fontWeight: 500,
  },
  icon: {
    marginLeft: theme.spacing(0.5),
    cursor: 'pointer',
    fontSize: '14px',
    color: theme.palette.common.gray600,
  },
  labelDate: {
    width: 'fit-content',
  },
  sitesChip: {
    backgroundColor: theme.palette.common.gray600,
  },
}));

const SmaMonitoringPlanCard = ({ name, rcaId, sitesNames }) => {
  const classes = useStyles();
  return (
    <Box display="flex" alignItems="center" flexGrow={1} className={classes.container}>
      <Box display='flex' flexDirection="column" sx={{ p: 1, width: '100%' }}>
        <Box display="flex" alignItems="center">
          <Typography noWrap className={classes.title} variant="h6" color="textPrimary">
            {name}
          </Typography>
        </Box>
        <Box pb={0.5} display="flex">
          {sitesNames?.length > 0 &&
            sitesNames.map((siteName, index) =>
              <Box mr={0.2} mt={0.1} key={`${siteName}-${index}`}>
                <LabelChip
                  className={classes.sitesChip}
                  label={`Sitio | ${siteName}`}
                  color="secondary"
                />
              </Box>)
          }
          {rcaId.length > 0 &&
            <ListIndicator
              list={rcaId.map(id => `RCA | ${id}`)}
              hideCount
              maxItems={5}
              color='primary'
            />
          }
        </Box>
      </Box>
    </Box>
  );
};

SmaMonitoringPlanCard.propTypes = {
  name: PropTypes.string,
  sitesNames: PropTypes.arrayOf(PropTypes.string),
  rcaId: PropTypes.array,
};


export { SmaMonitoringPlanCard };
